import origCopy from "@assets/redesign/icons/copy.svg";
import wlpCopy from "@components/WLP202603/assets/redesign/icons/copy.svg";
import { WLP202603 } from "../../../config";
import Copy from "@components/global/new/Copy/Copy";
import mainLocationsStore from "@mobx/store/locations";
import { makeMinerName } from "@utils/parseMinerName";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import styles from "./BuildingAddress.module.scss";

const copy = WLP202603 ? wlpCopy : origCopy;

export interface IBuildingAddressProps {}

interface IBuildingAddressControl {
  readonly address: string;
  readonly activeRackName?: string;
  readonly activeMinerName?: string;
}

const useControl = (): IBuildingAddressControl => {
  const locationStore = mainLocationsStore.activeLocation;
  const buildingStore = locationStore?.activeBuilding;

  const activeMinerName = useMemo(() => {
    if (buildingStore?.activeMinerBLI) {
      return makeMinerName(buildingStore?.activeMinerBLI);
    }

    return buildingStore?.activeCellBLI;
  }, [buildingStore?.activeMinerBLI, buildingStore?.activeCellBLI]);

  return {
    address: `${locationStore?.location.Code}${buildingStore?.building.name}`,
    activeRackName: buildingStore?.activeRackBLI,
    activeMinerName: activeMinerName,
  };
};


const BuildingAddress3 = observer((props: IBuildingAddressProps) => {
  const { formatMessage } = useIntl();
  const control = useControl();
  const fullAddress = `${control.address}${control.activeRackName ?? ""}${
    control.activeMinerName ?? ""
  }`;
  return (
    <div className={styles.wrapper}>
      <p title={`Location ID + Building ID`}>
        {formatMessage({ id: "location.building.address" })} <span>{control.address}-</span>
        <span title={`Rack ID`}>{control.activeRackName || "XXXX"}</span>
        <span title={`XY`}>{control.activeMinerName || "XXXX"}</span>
      </p>
      <Copy text={fullAddress} icon={copy} className={styles.copy_icon} />
    </div>
  );
});

BuildingAddress3.displayName = "BuildingAddress3";

export default BuildingAddress3;
